// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  INonsecure,
  useAddNonsecure,
  useUpdateNonsecure,
  useGetAcquirerBankList,
  useGetAllMerchantList,
} from "../../../hooks";
import { Box, Stack, FormControl, Autocomplete, TextField, useTheme, useMediaQuery } from "@mui/material";
import {
  BaseModal,
  BaseModalProps,
  SelectControl,
  SwitchControl,
  InputControl,
  NumericFormatInputControl,
} from "../../molecules";
import { useEffect, useMemo, useState } from "react";
import { Button, Loading } from "../../atoms";
import { Controller, useForm } from "react-hook-form";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  nonsecureAddFormSchema,
  NonsecureAddFormSchemaFormValuesType,
  nonsecureAddInitialValues,
} from "./_formTypes";
import { useUserInfo } from "../../../store/User.state";
import { watch } from "fs";

export type NonsecureAddModalProps = BaseModalProps & {
  title?: string;
  nonsecureData?: INonsecure;
};

export const NonsecureAddModal = ({
  onClose,
  nonsecureData,
  isOpen,
  title = "Non Secure Tanımlama",
}: NonsecureAddModalProps) => {
  const { control, reset, handleSubmit,watch } =
    useForm<NonsecureAddFormSchemaFormValuesType>({
      resolver: zodResolver(nonsecureAddFormSchema),
      defaultValues: nonsecureAddInitialValues,
    });
    const [userInfo] = useUserInfo();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { data: rawAcquirerBankList } = useGetAcquirerBankList("ACTIVE");
  const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
  const { mutate: addParameter, isLoading } = useAddNonsecure();
  const { mutate: updateParameter, isLoading: isUpdateLoading } =
    useUpdateNonsecure();
    const [maxAmount, setMaxAmount] = useState(null);
  const setSnackbar = useSetSnackBar();

  const acquirerBankList = useMemo(() => {
    return rawAcquirerBankList?.data?.map(
      (bank: { bankCode: string; bankName: string }) => {
        return {
          label: `${bank.bankName}`,
          value: bank.bankCode,
        };
      }
    );
  }, [rawAcquirerBankList?.data]);

  // const merchantList = useMemo(() => {
  //   return rawMerchantList?.data?.map(
  //     (rawPosType: { merchantName: string; merchantId: number }) => {
  //       return {
  //         label: rawPosType.merchantName,
  //         value: rawPosType.merchantId,
  //       };
  //     }
  //   );
  // }, [rawMerchantList?.data]);

  const merchantList = useMemo(() => {
 
    if (userInfo.merchantId == 0) {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: rawPosType.merchantName,
                    value: rawPosType.merchantId,
                };
            }
        );
    } else {
        return rawMerchantList?.data
            ?.filter((rawPosType: { merchantName: string; merchantId: number }) => {
                return rawPosType.merchantId === Number(userInfo.merchantId);
            })
            .map((filteredMerchant) => {
                return {
                    label: filteredMerchant.merchantName,
                    value: filteredMerchant.merchantId,
                };
            });
    }
}, [rawMerchantList?.data, userInfo?.merchantId]);
  const onSubmit = (data: any) => {
    const formattedMaxAmount = parseFloat(data.maxAmount.replace(/\./g, '').replace(',', '.'));

    if (nonsecureData && nonsecureData?.id > 0) {
      updateParameter(
        { ...data, id: nonsecureData.id,  maxAmount: formattedMaxAmount },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              onClose();
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      addParameter({...data,  maxAmount: formattedMaxAmount }, {
        onSuccess(data) {
          if (data.isSuccess) {
            onClose();
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };

  useEffect(() => {
    if (!!nonsecureData && JSON.stringify(nonsecureData) !== "{}") {
      reset({
        merchantId: nonsecureData?.merchantId,
        bankCode: nonsecureData?.bankCode,
        threeDRequired: nonsecureData?.threeDRequired,
        maxAmount: nonsecureData?.maxAmount,
      });
    }
  }, [reset, nonsecureData]);

  useEffect(() => {
    if (isOpen === false) {
      reset({});
    }
  }, [isOpen]);


  return (
    <>
      {(isLoading || isUpdateLoading) && <Loading />}
      <BaseModal onClose={onClose} title={title} isOpen={isOpen}>
        <Stack flex={1} p={4}>
          {/* !!! --- FORM --- !!! */}
          <Stack spacing={2} flex={1}>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
          <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%" }}>
                {merchantList && (
                  <Controller
                    control={control}
                    name="merchantId"
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <Autocomplete
                      disabled={nonsecureData && nonsecureData?.id > 0} 
                        id="merchantId"
                        options={merchantList}
                        value={
                          merchantList.find(
                            (option) => option.value === value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const merchantValue = newValue
                            ? Number(newValue.value)
                            : null;
                          onChange(merchantValue);
                          setSelectedMerchantId(merchantValue);
                        }}
                        getOptionLabel={(option: {
                          label: string;
                          value: number;
                        }) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Üye İşyeri"
                            error={!!error} //
                            disabled={nonsecureData && nonsecureData?.id > 0} 
                          />
                        )}
                      />
                    )}
                  />
                )}
              </FormControl>

              <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%" }}>
                {acquirerBankList && (
                  <SelectControl
                    id="bankCode"
                    control={control}
                    label="Banka"
                    items={acquirerBankList}
                    disabled={nonsecureData && nonsecureData?.id > 0}
                  />
                )}
              </FormControl>
            </Stack>
            <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
         <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%" }}>
                <SwitchControl
                  defaultValue={false}
                  label="Nonsecure işlem yapılsın"
                  control={control}
                  id="threeDRequired"
                />
              </FormControl>
         <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%" }}>
                <NumericFormatInputControl
                  sx={{ flex: 1 }}
                  label="Maksimum Tutar"
                  control={control}
                  id="maxAmount"
                  adornmentText="TL"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale
                />
              </FormControl>
            </Stack>
          </Stack>
          {/* !!! --- Button --- !!! */}
          <Stack justifyContent="flex-end" alignItems="center" direction="row">
            <Button
              variant="contained"
              text={nonsecureData ? "Güncelle" : "Ekle"}
              onClick={handleSubmit(onSubmit)}
            />
          </Stack>
        </Stack>
      </BaseModal>
    </>
  );
};
